import { Link } from "react-router-dom";
import { Button } from "../components/ui/button"
import { Header } from "../components/header"
import { Footer } from "../components/footer"
import { HeroCarousel } from "../components/hero-carousel"
import { PublicMapPreview } from "../components/public-map-preview"
import img1 from "../assets/img/1.png";
import img2 from "../assets/img/2.png";
import img3 from "../assets/img/3.png";

export default function HomePage() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />

      {/* Hero Section */}
      <main className="flex-1">
        <HeroCarousel />

        {/* Feature 1 - img Left, Text Right */}
        <section className="py-20 bg-white">
          <div className="container mx-auto px-4">
            <div className="grid md:grid-cols-2 gap-12 items-center max-w-6xl mx-auto">
              <div className="relative h-[400px] rounded-2xl overflow-hidden shadow-2xl">
                <img
                  src={img2}
                  alt="Acceso instantáneo al stock"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="space-y-6">
                <div className="inline-block px-4 py-2 bg-[#0288d0]/10 rounded-full">
                </div>
                <h2 className="text-3xl md:text-4xl font-bold text-foreground text-balance">
                  Acceso instantáneo al stock cercano
                </h2>
                <p className="text-lg text-muted-foreground leading-relaxed text-pretty">
                  Encuentra bombonas de gas disponibles en tu área al instante con actualizaciones de stock en tiempo
                  real. No más llamadas telefónicas ni viajes innecesarios.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Feature 2 - Text Left, img Right */}
        <section className="py-20 bg-gradient-to-b from-white to-[#0288d0]/5">
          <div className="container mx-auto px-4">
            <div className="grid md:grid-cols-2 gap-12 items-center max-w-6xl mx-auto">
              <div className="space-y-6 md:order-1">
                <div className="inline-block px-4 py-2 bg-[#0288d0]/10 rounded-full">
                </div>
                <h2 className="text-3xl md:text-4xl font-bold text-foreground text-balance">
                  3 meses de prueba gratuita
                </h2>
                <p className="text-lg text-muted-foreground leading-relaxed text-pretty">
                  Obtén acceso completo a todas las funciones incluyendo filtros avanzados durante 3 meses completamente
                  gratis. Sin tarjeta de crédito requerida.
                </p>
              </div>
              <div className="relative h-[400px] rounded-2xl overflow-hidden shadow-2xl md:order-2">
                <img
                  src={img1}
                  alt="Acceso instantáneo al stock"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Feature 3 - img Left, Text Right */}
        <section className="py-20 bg-[#0288d0]/5">
          <div className="container mx-auto px-4">
            <div className="grid md:grid-cols-2 gap-12 items-center max-w-6xl mx-auto">
              <div className="relative h-[400px] rounded-2xl overflow-hidden shadow-2xl">
                <img
                  src={img3}
                  alt="Acceso instantáneo al stock"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="space-y-6">
                <div className="inline-block px-4 py-2 bg-[#0288d0]/10 rounded-full">
                </div>
                <h2 className="text-3xl md:text-4xl font-bold text-foreground text-balance">
                  Ahorra tiempo y recursos
                </h2>
                <p className="text-lg text-muted-foreground leading-relaxed text-pretty">
                  No pierdas el tiempo ni los recursos en busca de bombonas de gas si puedes ver todo desde el móvil.
                  Planifica tu compra de manera eficiente.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="py-12 bg-gradient-to-b from-white to-muted/20">
          <div className="container mx-auto px-4">
            <div className="text-center mb-8">
              <h2 className="text-3xl md:text-4xl font-bold mb-4 text-balance">Explora puntos de venta en Malabo</h2>
              <p className="text-lg text-muted-foreground max-w-2xl mx-auto text-pretty">
                Visualiza la ubicación de los vendedores de gas en tiempo real. Regístrate para acceder a todas las
                funciones.
              </p>
            </div>
            <div className="max-w-6xl mx-auto">
              <PublicMapPreview />
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-gradient-to-b from-[#0288d0]/5 to-white">
          <div className="container mx-auto px-4 text-center">
            <h2 className="text-3xl md:text-5xl font-bold text-foreground mb-6 text-balance">
              ¿Listo para encontrar gas cerca de ti?
            </h2>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto mb-8 text-pretty">
              Únete a GeoGas hoy y disfruta de 3 meses de acceso gratuito a todas nuestras funciones.
            </p>
            <Link href="/register">
              <Button size="lg" className="bg-[#0288d0] hover:bg-[#0288d0]/90 text-white px-8 py-6 text-lg">
                Comenzar Ahora
              </Button>
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  )
}
